export const TRANSLATIONS: Record<string, Record<string, string>> = {
    chatTitle: {
      English: 'Chat with Theo',
      Albanian: 'Bisedo me Theon',
      Amharic: 'ከTheo ጋር ይወያዩ',
      Arabic: 'الدردشة مع ثيو',
      Armenian: 'Զրուցել Թեոյի հետ',
      Bengali: 'থিওর সাথে চ্যাট করুন',
      Bosnian: 'Razgovaraj s Theom',
      Bulgarian: 'Чат с Тео',
      Burmese: 'သီယိုနှင့် စကားပြောပါ',
      Catalan: 'Xateja amb Theo',
      Chinese: '与Theo聊天',
      Croatian: 'Razgovaraj s Theom',
      Czech: 'Chat s Theem',
      Danish: 'Chat med Theo',
      Dutch: 'Chat met Theo',
      Estonian: 'Vestle Theoga',
      Finnish: 'Keskustele Theon kanssa',
      French: 'Discuter avec Theo',
      Georgian: 'ესაუბრე თეოს',
      German: 'Chatte mit Theo',
      Greek: 'Συνομιλήστε με τον Theo',
      Gujarati: 'Theo સાથે ચેટ કરો',
      Hindi: 'थियो से बात करें',
      Hungarian: 'Csevegj Theóval',
      Icelandic: 'Spjallaðu við Theo',
      Indonesian: 'Ngobrol dengan Theo',
      Italian: 'Chatta con Theo',
      Japanese: 'Theoとチャットする',
      Kannada: 'ಥಿಯೋ ಜೊತೆಗೆ ಚಾಟ್ ಮಾಡಿ',
      Kazakh: 'Теомен сөйлесу',
      Korean: 'Theo와 채팅하기',
      Latvian: 'Tērzēt ar Theo',
      Lithuanian: 'Pokalbis su Theo',
      Macedonian: 'Разговарај со Тео',
      Malay: 'Bual dengan Theo',
      Malayalam: 'Theoയുമായി ചാറ്റ് ചെയ്യുക',
      Marathi: 'Theo सोबत गप्पा मारा',
      Mongolian: 'Theo-той чатлах',
      Norwegian: 'Chat med Theo',
      Persian: 'چت با تئو',
      Polish: 'Czat z Theo',
      Portuguese: 'Conversar com Theo',
      Punjabi: 'ਥਿਓ ਨਾਲ ਗੱਲਬਾਤ ਕਰੋ',
      Romanian: 'Discută cu Theo',
      Russian: 'Чат с Тео',
      Serbian: 'Ćaskaj sa Teom',
      Slovak: 'Chat s Theom',
      Slovenian: 'Klepetaj s Theom',
      Somali: 'La sheekeyso Theo',
      Spanish: 'Chatea con Theo',
      Swahili: 'Zungumza na Theo',
      Swedish: 'Chatta med Theo',
      Tagalog: 'Makipag-chat kay Theo',
      Tamil: 'Theo உடன் உரையாடுங்கள்',
      Telugu: 'Theoతో చాట్ చేయండి',
      Thai: 'แชทกับธีโอ',
      Turkish: 'Theo ile sohbet et',
      Ukrainian: 'Чат з Тео',
      Urdu: 'تھیو کے ساتھ چیٹ کریں',
      Vietnamese: 'Trò chuyện với Theo',
    },
    sendButton: {
      English: 'Send',
      Albanian: 'Dërgo',
      Amharic: 'ላክ',
      Arabic: 'إرسال',
      Armenian: 'Ուղարկել',
      Bengali: 'পাঠান',
      Bosnian: 'Pošalji',
      Bulgarian: 'Изпрати',
      Burmese: 'ပေးပို့ပါ',
      Catalan: 'Envia',
      Chinese: '发送',
      Croatian: 'Pošalji',
      Czech: 'Odeslat',
      Danish: 'Send',
      Dutch: 'Verzenden',
      Estonian: 'Saada',
      Finnish: 'Lähetä',
      French: 'Envoyer',
      Georgian: 'გაგზავნა',
      German: 'Senden',
      Greek: 'Αποστολή',
      Gujarati: 'મોકલો',
      Hindi: 'भेजें',
      Hungarian: 'Küldés',
      Icelandic: 'Senda',
      Indonesian: 'Kirim',
      Italian: 'Invia',
      Japanese: '送信',
      Kannada: 'ಕಳುಹಿಸಿ',
      Kazakh: 'Жіберу',
      Korean: '보내기',
      Latvian: 'Sūtīt',
      Lithuanian: 'Siųsti',
      Macedonian: 'Испрати',
      Malay: 'Hantar',
      Malayalam: 'അയയ്ക്കുക',
      Marathi: 'पाठवा',
      Mongolian: 'Илгээх',
      Norwegian: 'Send',
      Persian: 'ارسال',
      Polish: 'Wyślij',
      Portuguese: 'Enviar',
      Punjabi: 'ਭੇਜੋ',
      Romanian: 'Trimite',
      Russian: 'Отправить',
      Serbian: 'Pošalji',
      Slovak: 'Odoslať',
      Slovenian: 'Pošlji',
      Somali: 'Dir',
      Spanish: 'Enviar',
      Swahili: 'Tuma',
      Swedish: 'Skicka',
      Tagalog: 'Ipadala',
      Tamil: 'அனுப்பு',
      Telugu: 'పంపండి',
      Thai: 'ส่ง',
      Turkish: 'Gönder',
      Ukrainian: 'Надіслати',
      Urdu: 'بھیجیں',
      Vietnamese: 'Gửi',
    },
    inputPlaceholder: {
      English: 'Type your message here',
      Albanian: 'Shkruani mesazhin tuaj këtu',
      Amharic: 'መልእክትዎን እዚህ ይተይቡ',
      Arabic: 'اكتب رسالتك هنا',
      Armenian: 'Մուտքագրեք ձեր հաղորդագրությունը այստեղ',
      Bengali: 'এখানে আপনার বার্তা টাইপ করুন',
      Bosnian: 'Ovdje upišite svoju poruku',
      Bulgarian: 'Въведете съобщението си тук',
      Burmese: 'သင်၏မက်ဆေ့ခ်ျကို ဤနေရာတွင် ရိုက်ထည့်ပါ',
      Catalan: 'Escriu el teu missatge aquí',
      Chinese: '在此输入您的消息',
      Croatian: 'Ovdje upišite svoju poruku',
      Czech: 'Zde napište svou zprávu',
      Danish: 'Skriv din besked her',
      Dutch: 'Typ hier je bericht',
      Estonian: 'Sisestage siia oma sõnum',
      Finnish: 'Kirjoita viestisi tähän',
      French: 'Tapez votre message ici',
      Georgian: 'შეიყვანეთ თქვენი შეტყობინება აქ',
      German: 'Geben Sie hier Ihre Nachricht ein',
      Greek: 'Πληκτρολογήστε το μήνυμά σας εδώ',
      Gujarati: 'અહીં તમારું સંદેશ લખો',
      Hindi: 'यहां अपना संदेश टाइप करें',
      Hungarian: 'Írja be ide az üzenetét',
      Icelandic: 'Sláðu inn skilaboðin þín hér',
      Indonesian: 'Ketik pesan Anda di sini',
      Italian: 'Scrivi il tuo messaggio qui',
      Japanese: 'ここにメッセージを入力してください',
      Kannada: 'ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ಇಲ್ಲಿ ಟೈಪ್ ಮಾಡಿ',
      Kazakh: 'Мұнда хабарламаңызды теріңіз',
      Korean: '여기에 메시지를 입력하세요',
      Latvian: 'Ierakstiet savu ziņojumu šeit',
      Lithuanian: 'Įveskite savo žinutę čia',
      Macedonian: 'Внесете ја вашата порака овде',
      Malay: 'Taip mesej anda di sini',
      Malayalam: 'നിങ്ങളുടെ സന്ദേശം ഇവിടെ ടൈപ്പ് ചെയ്യുക',
      Marathi: 'आपला संदेश येथे टाइप करा',
      Mongolian: 'Энд мессежээ бичнэ үү',
      Norwegian: 'Skriv meldingen din her',
      Persian: 'پیام خود را اینجا تایپ کنید',
      Polish: 'Wpisz swoją wiadomość tutaj',
      Portuguese: 'Digite sua mensagem aqui',
      Punjabi: 'ਇੱਥੇ ਆਪਣਾ ਸੁਨੇਹਾ ਲਿਖੋ',
      Romanian: 'Scrieți mesajul dvs. aici',
      Russian: 'Введите ваше сообщение здесь',
      Serbian: 'Ovde unesite svoju poruku',
      Slovak: 'Napíšte svoju správu sem',
      Slovenian: 'Vnesite svoje sporočilo tukaj',
      Somali: 'Halkan ku qor fariintaada',
      Spanish: 'Escribe tu mensaje aquí',
      Swahili: 'Andika ujumbe wako hapa',
      Swedish: 'Skriv ditt meddelande här',
      Tagalog: 'I-type ang iyong mensahe dito',
      Tamil: 'உங்கள் செய்தியை இங்கே தட்டச்சு செய்யவும்',
      Telugu: 'మీ సందేశాన్ని ఇక్కడ టైప్ చేయండి',
      Thai: 'พิมพ์ข้อความของคุณที่นี่',
      Turkish: 'Mesajınızı buraya yazın',
      Ukrainian: 'Введіть ваше повідомлення тут',
      Urdu: 'اپنا پیغام یہاں ٹائپ کریں',
      Vietnamese: 'Nhập tin nhắn của bạn tại đây',
    },
    selectLanguage: {
        English: 'Select Language',
        Albanian: 'Zgjidh gjuhën',
        Amharic: 'ቋንቋ ይምረጡ',
        Arabic: 'اختر اللغة',
        Armenian: 'Ընտրեք լեզուն',
        Bengali: 'ভাষা নির্বাচন করুন',
        Bosnian: 'Odaberite jezik',
        Bulgarian: 'Изберете език',
        Burmese: 'ဘာသာစကားရွေးပါ',
        Catalan: 'Selecciona l\'idioma',
        Chinese: '选择语言',
        Croatian: 'Odaberite jezik',
        Czech: 'Vyberte jazyk',
        Danish: 'Vælg sprog',
        Dutch: 'Selecteer taal',
        Estonian: 'Vali keel',
        Finnish: 'Valitse kieli',
        French: 'Choisir la langue',
        Georgian: 'აირჩიეთ ენა',
        German: 'Sprache wählen',
        Greek: 'Επιλέξτε γλώσσα',
        Gujarati: 'ભાષા પસંદ કરો',
        Hindi: 'भाषा चुनें',
        Hungarian: 'Válassz nyelvet',
        Icelandic: 'Veldu tungumál',
        Indonesian: 'Pilih bahasa',
        Italian: 'Seleziona la lingua',
        Japanese: '言語を選択',
        Kannada: 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        Kazakh: 'Тілді таңдаңыз',
        Korean: '언어 선택',
        Latvian: 'Izvēlieties valodu',
        Lithuanian: 'Pasirinkite kalbą',
        Macedonian: 'Изберете јазик',
        Malay: 'Pilih bahasa',
        Malayalam: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
        Marathi: 'भाषा निवडा',
        Mongolian: 'Хэл сонгох',
        Norwegian: 'Velg språk',
        Persian: 'زبان را انتخاب کنید',
        Polish: 'Wybierz język',
        Portuguese: 'Selecione o idioma',
        Punjabi: 'ਭਾਸ਼ਾ ਚੁਣੋ',
        Romanian: 'Selectați limba',
        Russian: 'Выберите язык',
        Serbian: 'Izaberite jezik',
        Slovak: 'Vyberte jazyk',
        Slovenian: 'Izberite jezik',
        Somali: 'Dooro luqadda',
        Spanish: 'Seleccionar idioma',
        Swahili: 'Chagua lugha',
        Swedish: 'Välj språk',
        Tagalog: 'Piliin ang wika',
        Tamil: 'மொழியை தேர்ந்தெடுக்கவும்',
        Telugu: 'భాషను ఎంచుకోండి',
        Thai: 'เลือกภาษา',
        Turkish: 'Dil seçin',
        Ukrainian: 'Виберіть мову',
        Urdu: 'زبان منتخب کریں',
        Vietnamese: 'Chọn ngôn ngữ',
      },      
  };
  